<template>
  <div class="data-list--row">
    <div class="row row--1"><slot name="col-title" /></div>
    <div class="row row--2"><slot name="col-value" /></div>
  </div>
</template>

<script>
export default {
  name: 'BrainsDataRow'
}
</script>

<style lang="scss" scoped>
.data-list--row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .row {
    width: 45%;
    padding: 5px;
    text-align: left;
    font-size: 13px;

    &--1 {
      font-family: "Montserrat-SemiBold",sans-serif;
    }

    &--2 {
      font-family: "Montserrat-Light",sans-serif;
    }
  }
}
</style>
